import $ from 'jquery';
import {querystring} from 'linksoft';
import assign from 'lodash/assign';
import {getEditor} from '../editor';

$.fn.DataTable.Api.register('name()', function () {
    return this.init().name;
});

$.fn.DataTable.Api.register('primaryKey()', function () {
    return this.init().rowId || 'id';
});

$.fn.DataTable.Api.register('editor()', function () {
    return getEditor(this.table().node());
});

$.fn.DataTable.Api.register('sumCellShow()', function () {
    $(this.table().header()).find(`tr.column-sums-error`).hide();
    $(this.table().header()).find(`tr.column-sums`).show();
});

$.fn.DataTable.Api.register('sumCellError()', function (text) {
    $(this.table().header()).find(`tr.column-sums`).hide();
    $(this.table().header()).find(`tr.column-sums-error`).show().children(":first").text(text || '(Sum is not supported for current filter)');


});

$.fn.DataTable.Api.register('rowId()', function (rowData) {
    const id = rowData && rowData[this.primaryKey()];
    if (id) {
        return `${this.name()}_row_${id}`;
    }
});

/**
 * Use this API method to update query string parameters for ajax URL.
 *
 * Usage:
 *
 * $('#myTable').DataTable().query(qs => { qs.myParam = 'newValue'; });
 */
$.fn.DataTable.Api.register('query()', function (dataOrCallback) {
    return this.iterator('table', function (ctx) {
        let url = this.ajax.url();
        const cb = typeof(dataOrCallback) !== 'function' ? function (qs) {
            if (typeof dataOrCallback === 'object') {
                assign(qs, dataOrCallback);
            }
        } : dataOrCallback;

        url = querystring.modify(url, cb);
        this.ajax.url(url);
    });
});

/**
 * Returns object with enum values for the given column.
 *
 * Usage:
 * $('#myTable').DataTable().enumValues(2);
 */
// $.fn.DataTable.Api.register('enumValues()', function(columnSelector) {
//     const column = this.column(columnSelector);
//     return column && column.enumValues();
// });


$.fn.DataTable.Api.register('clearFilters()', function () {
    // clear custom/external filters
    $(this.init().customFilters)
        .each(function () {
            $(this).val('');
        });

    // clear global filter
    this.search('');

    // clear column filters
    this.columns().every(function () {
        this.search('');
    }).draw();
});


// WEBPACK FOOTER //
// ./node_modules/linksoft-datatables/src/api/tableExtensions.js